{
  "loading": "Зареждане...",
  "placeholder": "Изберете…"
}
